import React from "react";

export default function EMIBehaviorCards({ totalActiveLoans, stages, selectedMonth }) {
  const cards = [
    {
      title: "Total Active Loans",
      value: totalActiveLoans?.toLocaleString() || "0",
      subtitle: "All EMI stages",
      bg: "linear-gradient(135deg,#6A7282,#4b5563)",
    },
    ...(stages || []).map((stage) => ({
      title: stage.stageLabel,
      value: stage.activeLoans?.toLocaleString() || "0",
      subtitle: `${stage.shareOfTotal?.toFixed(1) || 0}% of total`,
      bg: stage.stageKey === 1
        ? "linear-gradient(135deg,#2B7FFF,#155DFC)"
        : stage.stageKey === 2
        ? "linear-gradient(135deg,#00C950,#00A63E)"
        : "linear-gradient(135deg,#F0B100,#D08700)",
    })),
  ];

  return (
    <div className="emi-behavior" style={{ marginTop: "40px" }}>
      <div className="emi-behavior__header">
        <h4
          // className="emi-behavior__title"
          style={{ color: "#0A0A0A", fontWeight: "600", fontSize: "20px" }}
        >
          EMI Behavior Tracking
        </h4>

        <p
          className="emi-behavior__month"
          style={{ color: "#4A5565", fontSize: "14px", fontWeight: "400" }}
        >
            {selectedMonth?.length > 0
                ? `Month: ${selectedMonth?.join(", ")}`
                : "No months selected"}
        </p>
      </div>

      <div className="emi-behavior__grid">
        {cards.map((card, index) => (
          <div
            key={index}
            className="emi-behavior__card"
            style={{ background: card.bg }}
          >
            <p className="emi-behavior__card-title">{card.title}</p>

            <h4 className="emi-behavior__card-value">{card.value}</h4>

            <p className="emi-behavior__card-subtitle">{card.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
